export default __webpack_public_path__ + "static/media/home_icon.a3a29287.svg";